import {createBrowserHistory} from 'history';
import { sidebar_store } from '@components/Sidebar/Sidebar';
import { getNavNodeByMatchPath } from '@common/NavConfig'

let history = createBrowserHistory();

let unlisten = history.listen((location,actions) => {
  console.log(getNavNodeByMatchPath(location.pathname))
  sidebar_store.setPathArray();
});

export default history;



// WEBPACK FOOTER //
// ./src/history.js